import React, { FC, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SuccessBg from 'assets/images/success.png';
import FailBg from 'assets/images/failed.png';
import { Button } from '../../button/button.index';
import { API } from 'data/30pay.api';
import { get, post } from 'scripts';
import ENV from 'env.json';
import SiPayPanelInitialLoading from '30pay/initialLoading/initialLoading.index';
export const AuthenticateThankYouPage: FC = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'failed'>('loading');

    useEffect(() => {
        const userid = searchParams.get('userid');
        if (!userid) {
            setStatus('failed');
            return;
        }

        post(API.level.verifyUpgradeTo2, { userid })
            .then((res) => {
                if (res.status === 200) {
                    setStatus('success');
                } else {
                    setStatus('failed');
                }
            })
            .catch(() => setStatus('failed'));
    }, [searchParams]);

    if (status === 'loading') {
        return <SiPayPanelInitialLoading />;
    }

    return (
        <div className="flex flex-col items-center justify-center gap-8 min-h-screen min-w-screen">
            <div className="flex flex-col items-center justify-center gap-8 max-w-[500px]">
                <img className="w-full" src={status === 'success' ? SuccessBg : FailBg} alt="Status" />
                <h1
                    className={`text-xl font-bold ${status === 'success' ? 'text-positive-dark' : 'text-negative-dark'}`}
                >
                    {status === 'success' ? 'احراز هویت شما با موفقیت انجام شد.' : 'احراز هویت شما موفق آمیز نبود!'}
                </h1>
                <p className="text-center font-medium text-base text-black-100">
                    {status === 'success'
                        ? 'برای ادامه به پنل کاربری مراجعه فرمایید'
                        : 'احراز هویت شما ناموفق بوده٬ لطفا دوباره تلاش کنید.'}
                </p>
                <Link className="w-full" to={ENV.panel}>
                    <Button type="primary" className="w-full min-h-14">
                        برگشت به پنل کاربری
                    </Button>
                </Link>
            </div>
        </div>
    );
};
